import getFormDataFromObject from "../helpers/getFormDataFromObject";

/**
 * @function createFolder
 * @param  {type} nodeData {description}
 * @param  {type} callback {description}
 * @return {type} {description}
 */
export default async (nodeData, callback) => {
  let guid = CodeEditor.GUID();
  const request = fetch("/api/v1/code_editor/", {
    method: "POST",
    headers: {
      "x-csrf-token": $("meta[name='csrf-token']").attr("content")
    },
    credentials: "include",
    body: getFormDataFromObject({
      key: "",
      path: nodeData.path || "untitled_folder" + guid,
      reference: nodeData.reference || "untitled_folder" + guid,
      file_type: nodeData.file_type || "",
      rename: true,
      folder: true,
      theme_id: CodeEditor.Main.themeId(),
      socket_id: window.socketId
    })
  });
  try {
    let resp = await request;
    resp = await resp.json();
    if (resp.success) {
      typeof nodeData.success == "function" && nodeData.success();
      typeof callback === "function" && callback();
      return true;
    }
    console.trace();
    console.error("failed to process a callback to the caller 😱 , see above trace ");
    console.error(resp);
    typeof nodeData.fail == "function" && nodeData.fail();
  } catch (error) {
    console.error(`couldn't create folder due to error: " ${error}`);
    console.error("failed to process a callback to the caller 😱", console.trace());
    typeof nodeData.error == "function" && nodeData.error();
  }
};
